import * as React from 'react';
import { OrderByEnum } from '../../data-grid.type';
import { SortIndicator } from './sort-indicator';
import { Button, ButtonVariant } from '@components/molecules';
import { cn } from '@utils';

interface BasicHeaderProps {
	isActiveSortColumn?: boolean;
	title: string;
	columnSort: OrderByEnum;
	className?: string;
	onClick: () => void;
}

export const BasicHeader: React.FC<BasicHeaderProps> = ({
	className,
	columnSort,
	isActiveSortColumn,
	onClick,
	title,
}: BasicHeaderProps) => {
	return (
		<Button
			variant={ButtonVariant.TABLEHEADER}
			size="xs"
			className={cn(
				'truncate text-left align-middle',
				className
			)}
			onClick={onClick}
		>
			<span>{title}</span>
			<SortIndicator
				columnSort={columnSort}
				isActive={isActiveSortColumn}
			/>
		</Button>
	);
};
